import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Badge, Button, Card, CardBody, Container, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DATABASE_CLIENT_EDIT, DATABASE_CLIENT_FORM } from "../../routes/routeConstants";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { clientActions } from "./clientSlice";

function ClientPage() {
    const { t } = useTranslation('translation');
    const dispatch = useDispatch();
    const [record, setRecord] = useState({ open: false, data: null });
    const { clients, total } = useSelector(state => state.client);

    const breadcrumbItems = [
        { title: t('database'), link: "#" },
        { title: t('client'), link: "#" },
    ];

    const navigate = useNavigate();

    useEffect(() => {
        //load();
    }, []);

    const load =  () => {
        let query = {
            // criteria: { code: code, description: description },
            // page: page,
            size: 5,
        };
        dispatch(clientActions.search(query));
    }

    const downloadTemp = () => {
        let payload = {
            onSuccess: (response) => {
                var blob = new Blob([Uint8Array.from(atob(response), c => c.charCodeAt(0))], { type: "application/vnd.ms-excel" });
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = 'temp.xlsx';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            }
        }
        dispatch(clientActions.downloadTemp(payload));
    }

    const handleDelete = (cellProps) => {
        setRecord({ open: true, data: cellProps });
    }

    const confirmDelete = () => {
        setRecord({ ...record, open: false });
        let payload = {
            id: record.data.id,
            onSuccess: () => {
                load();
            },
            onError: (error) => {
                console.log(error);
            },
        };
        dispatch(clientActions.delete(payload));
    }

    const columns = useMemo(
        () => [
            {
                Header: t('clientf.type'),
                accessor: "type",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: t('clientf.raison'),
                accessor: "raison",
                disableFilters: true,
                filterable: false,
            },
            
            
            {
                Header: t('action'),
                accessor: (cellProps) => {
                    return (
                        <React.Fragment>
                            <Link to={DATABASE_CLIENT_EDIT.replace(":id", cellProps.id)} className="me-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link>
                            <Link onClick={() => handleDelete(cellProps)} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                        </React.Fragment>
                    )
                },
                disableFilters: true,
                filterable: false,
            },
        ],
        []
    );

    const uploadData = (event) => {
        const files = event.target.files;
        const formData = new FormData();
        formData.append("file", files[0]);
        let payload = {
            formData: formData,
            onSuccess: () => {
                dispatch(clientActions.list());
            },
            onError: (error) => {
                console.log(error);
            },
        };
        dispatch(clientActions.uploadData(payload));
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title={t('client')} breadcrumbItems={breadcrumbItems} />
                    <Card>
                        <CardBody>
                            <TableContainer
                            canUpload={true}
                            withPages={true}
                                columns={columns || []}
                                data={clients ?? []}
                                isPagination={true}
                                isAddClientList={true}
                                canDownloadtemp={true}
                                customPageSizeOptions={true}
                                iscustomPageSize={false}
                                handleClientClick={() => navigate(DATABASE_CLIENT_FORM)}
                                handleDownloadTemp={() => downloadTemp()}
                                handleUpload={uploadData}
                                isBordered={false}
                                customPageSize={10}
                            />
                        </CardBody>
                    </Card>
                </Container>
            </div>
            <Modal
                isOpen={record.open}
                toggle={() => setRecord({ ...record, open: false })}
                backdrop="static"
            >
                <ModalHeader toggle={() => setRecord({ ...record, open: false })}>
                    {t('text.confirmation')}
                </ModalHeader>
                <ModalBody>
                    <p>
                        {t('text.msgDelete')}
                    </p>
                    <ModalFooter>
                        <Button type="button" color="light" onClick={() => setRecord({ ...record, open: false })}>{t('actions.close')}</Button>
                        <Button type="button" color="primary" onClick={confirmDelete}>{t('actions.confirm')}</Button>
                    </ModalFooter>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default ClientPage;
